export default __webpack_public_path__ + "static/media/Megosu---Falstaff.59eac4dc.jpg";